<ejs-dialog #dialog [buttons]='dlgButtons' isModal='true' [animationSettings]='animationSettings' zIndex='8001'
    [closeOnEscape]='false' [showCloseIcon]='false' [customers]='customers'>

    <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" tabindex="0" role="heading" aria-label="Select a company" aria-level="3"> Select a company</h3>
        </div>
        <div class="card-body">
            <p role="paragraph" tabindex="0" aria-label="Pick a company">Before you start, let's pick a company to work with.</p>
            <ejs-dropdownlist #csCustomersddw id='csCustomersddw' [dataSource]='customers' [fields]='fields'
                (change)='customerChanged($event)' [placeholder]='customersWaterMark' [popupHeight]='ddwHeight'>
            </ejs-dropdownlist>
        </div>
    </div>
</ejs-dialog>
